import type { QualifyFallback } from '../lib/api/types';

interface Props {
  fallback: QualifyFallback;
  onRetry?: () => void;
}

const FRIENDLY_REASONS: Record<QualifyFallback['reason'], string> = {
  no_active_advisors:
    "We couldn't reach a team member to match you with right now. We'll follow up shortly.",
  rate_limited:
    "We've received your request. To prevent automated abuse, we limit submissions per network. We'll follow up by email.",
  duplicate_booking:
    'It looks like you already have an upcoming meeting with us.',
  turnstile_failed:
    "We couldn't verify your browser session. Please refresh and try again.",
  honeypot_tripped:
    "We couldn't process this submission. Please refresh and try again.",
  invalid_input:
    'Some of the information looks off — please double-check and try again.',
  internal_error:
    'Something went wrong on our end. Your information has been saved and a team member will reach out shortly.',
};

export function Fallback({ fallback, onRetry }: Props) {
  const friendly = FRIENDLY_REASONS[fallback.reason];
  const showRetry =
    fallback.reason === 'invalid_input' ||
    fallback.reason === 'turnstile_failed' ||
    fallback.reason === 'honeypot_tripped';

  return (
    <div className="fallback-state">
      <div className="fallback-icon" aria-hidden="true">!</div>
      <h2 className="fallback-headline">We've got your information</h2>
      <p className="fallback-message">{friendly}</p>
      <p className="fallback-followup">
        Reach out directly to{' '}
        <a href="mailto:scheduler@annuityassociation.com">
          scheduler@annuityassociation.com
        </a>{' '}
        and a team member will help you schedule personally.
      </p>
      {showRetry && onRetry && (
        <button className="submit-btn submit-btn-secondary" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
